module.exports = __webpack_public_path__ + "img/shortcut_net_off.65968ebb.svg";